import { useSyncExternalStore } from "react";

import { useActualViewer } from "../session/records";

/**
 * Onboarding is finished once the signed-in user picks one of the options the agent offers on Get Started. Saved per
 * account, in this browser: another browser offers Get Started again.
 */
const key = (viewerId: string) => `softmax-get-started:${viewerId}:finished`;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  window.addEventListener("storage", listener);

  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", listener);
  };
}

export function finishOnboarding(viewerId: string) {
  localStorage.setItem(key(viewerId), "1");

  for (const listener of listeners) listener();
}

/**
 * Whether to offer the signed-in viewer Get Started. No until the browser can say, so someone who has finished never
 * sees the link flash. A signed-out visitor has no account to ask about, and gets the header's own Get Started action.
 */
export function useOnboardingOpen() {
  const viewerId = useActualViewer().data?.subject_id ?? null;

  return useSyncExternalStore(
    subscribe,
    () => viewerId !== null && localStorage.getItem(key(viewerId)) === null,
    () => false,
  );
}
